import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faCheck, faDollarSign, faEdit, faFilter, faHashtag, faPlus, faPrint, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { currencyFormat } from '../../js/Functions';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PDFQuotations from './PDFQuotations';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        filename: '',
        description: '',
        hud_number: '',
        amount: '',
        sub_total: 0,
        taxes: 0,
        discounts: 0,
        total: 0,
        quotations: [],
        quotationItems: [],
        quotationItem: [],
        quotationData: [],
        errors: []
    }
    changeValue = (e) => {
        const state = this.state.quotations;
        state[e.target.name] = e.target.value;
        this.setState({ quotations: state });
    };
    changeValueItem = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    };
    changeValueEditItem = (e) => {
        const state = this.state.quotationItem;
        state[e.target.name] = e.target.value;
        this.setState({ quotationItem: state });
    }
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    calculateTotal = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: parseFloat(value) || 0 }, () => {
            const { sub_total, taxes, discounts } = this.state;
            const total = sub_total + taxes - discounts;
            this.setState({ total })
        });
    }
    createItem() {
        const { description, hud_number, amount } = this.state;
        var errors = [];
        if (!description) { errors.push("error_description"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            id_quotation: this.props.match.params.id,
            description: description,
            hud_number: hud_number,
            amount: amount,
            user_id: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("quotations/register_item", data)
            .then((dataResult) => {
                console.log(dataResult)
                var status = dataResult.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (dataResult.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Quotations!',
                        dataResult.data.msj,
                        'success'
                    )
                    this.setState({
                        description: '',
                        hud_number: '',
                        amount: '',
                    })
                } else {
                    Swal.close();
                    Swal.fire(
                        'Quotations!',
                        dataResult.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
        this.loadItems();
    }
    editItem() {
        const description = document.getElementById('edit_description').value;
        var errors = [];
        if (!description) { errors.push("error_edit_description"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        let form = document.getElementById('form_item_quotation');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("quotations/update_item", formData)
            .then((dataResult) => {
                console.log(dataResult)
                Swal.close();
                Swal.fire(
                    'Quotations!',
                    dataResult.data.msj,
                    'success'
                )
            })
            .catch(console.log)
        this.loadItems();
    }
    viewItem = (id) => {
        Swal.showLoading();
        authAxios.get("quotations/view_item/" + id)
            .then((dataResult) => {
                console.log(dataResult);
                if (dataResult.status) {
                    this.setState({
                        quotationItem: dataResult.data
                    });
                }
                Swal.close();
            })
            .catch(console.log);
    }
    deleteItem = (id) => {
        Swal.fire({
            title: 'Are you sure to Delete the Item?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Delete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                authAxios.get("quotations/delete_item/" + id)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Deleted!', dataResult.data.msj, 'success')
                        this.loadItems();
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    };
    approveQuote() {
        Swal.fire({
            title: 'Are you sure to Approve the Quotation?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                var data = {
                    id_quotation: this.props.match.params.id,
                    user_id: window.localStorage.getItem('idusuario')
                }
                authAxios.post("quotations/approve", data)
                    .then((dataResult) => {
                        Swal.showLoading();
                        console.log(dataResult);
                        Swal.fire('Approved!', dataResult.data.msj, 'success')
                            .then(() => {
                                this.setState((prevState) => ({
                                    quotations: {
                                        ...prevState.quotations,
                                        STATUS: 2
                                    }
                                }));
                                // this.props.history.push("/UpQuotations/" + dataResult.data.ID_QUOTATION);
                            });
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    }
    disapproveQuote() {
        Swal.fire({
            title: 'Are you sure to Disapprove the Quotation?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                var data = {
                    id_quotation: this.props.match.params.id,
                    user_id: window.localStorage.getItem('idusuario')
                }
                authAxios.post("quotations/disapprove", data)
                    .then((dataResult) => {
                        Swal.showLoading();
                        console.log(dataResult);
                        Swal.fire('Disapproved!', dataResult.data.msj, 'success')
                            .then(() => {
                                this.setState((prevState) => ({
                                    quotations: {
                                        ...prevState.quotations,
                                        STATUS: 1
                                    }
                                }));
                                // this.props.history.push("/UpQuotations/" + dataResult.data.ID_QUOTATION);
                            });
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    }
    cancelQuote() {
        Swal.fire({
            title: 'Are you sure to Cancel the Quotation?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                var data = {
                    id_quotation: this.props.match.params.id,
                    user_id: window.localStorage.getItem('idusuario')
                }
                authAxios.post("quotations/cancel", data)
                    .then((dataResult) => {
                        Swal.showLoading();
                        console.log(dataResult);
                        Swal.fire('Canceled!', dataResult.data.msj, 'success')
                        .then(() => {
                            this.setState((prevState) => ({
                                quotations: {
                                    ...prevState.quotations,
                                    STATUS: 3
                                }
                            }));
                            this.props.history.push("/UpQuotations/" + dataResult.data.ID_QUOTATION);
                        });
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    }
    sendData = (e) => {
        e.preventDefault();
        let form = document.getElementById('form_quotation');
        let formData = new FormData(form);
        Swal.showLoading();
        authAxios.post("quotations/update", formData)
            .then((dataResult) => {
                console.log(dataResult)
                Swal.close();
                Swal.fire(
                    'Quotations!',
                    dataResult.data.msj,
                    'success'
                )
                this.props.history.push("/UpQuotations/" + dataResult.data.ID_QUOTATION);
            })
            .catch(console.log)
    }
    loadItems() {
        authAxios.get("quotations/items/" + this.props.match.params.id)
            .then((dataResult) => {
                Swal.showLoading();
                console.log(dataResult);
                if (dataResult.data.status) {
                    this.setState({
                        quotationItems: dataResult.data.items,
                        sub_total: dataResult.data.sub_total,
                        taxes: dataResult.data.quotation.taxes,
                        discounts: dataResult.data.quotation.discounts,
                        total: dataResult.data.quotation.total,
                    });
                } else {
                    this.setState({
                        quotationItems: [],
                        sub_total: 0
                    });
                }
                Swal.close();
            })
            .catch(console.log);
    }
    previewPDFQuotations = (id_quotation) => {
        authAxios.get(`quotations/generate_quotation/${id_quotation}`)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }         
                const filename = `TC Transport - Quotation #${dataResult.data.quotation.ID_QUOTATION}.pdf`
                this.setState({
                    quotationData: dataResult.data,
                    filename: filename
                });
            })
            .catch((error) => console.log(error))
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("quotations/view/" + this.props.match.params.id)
            .then((dataResult) => {
                Swal.showLoading();
                console.log(dataResult);
                this.setState({
                    quotations: dataResult.data.result,
                    load: ''
                });
            })
            .catch(console.log);
        this.loadItems();
    }
    render() {
        const { load, filename, description, hud_number, amount, sub_total, taxes, discounts, total, quotations, quotationItems, quotationItem, quotationData } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {
                                    load ?
                                        (<b>{load}</b>)
                                    :
                                        (<b>UPDATE QUOTATION</b>)
                                }
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData} id="form_quotation">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="row g-3">
                                                <div className="col-md-12 text-right">
                                                    {
                                                        quotations.STATUS === 1 ?
                                                            <button type="button" className="btn btn-success btn-sm"
                                                                onClick={() => this.approveQuote()}
                                                            >
                                                                <FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Approve Quote</button>
                                                        : ''
                                                    }
                                                    {
                                                        quotations.STATUS === 2 ?
                                                            <button type="button" className="btn btn-success btn-sm"
                                                                onClick={() => this.disapproveQuote()}
                                                            >
                                                                <FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Disapprove Quote</button>
                                                        : ''
                                                    }
                                                    &nbsp;&nbsp;<button type="button" className="btn btn-danger btn-sm" onClick={() => this.cancelQuote()}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel Quote</button>&nbsp;&nbsp;
                                                    {
                                                        quotations.STATUS === 2 ?
                                                            <button type="button" className="btn btn-secondary btn-sm" data-bs-toggle='modal' data-bs-target="#PDFQuotationsModal" slot='end'
                                                                onClick={() => {
                                                                    this.previewPDFQuotations(quotations.ID_QUOTATION)
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;Print Quotation
                                                            </button>
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>QUOTATION INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id_quotation" value={this.props.match.params.id} />
                                                    <input type="hidden" name="user_id" id="user_id" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="quotation_id">Quotation ID.</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="quotation_id" id="quotation_id" defaultValue={quotations.ID_QUOTATION}
                                                            className="form-control form-control-sm" placeholder="Quotation ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="quotation_date">Quotation Date</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="quotation_date" id="quotation_date" defaultValue={quotations.QUOTATION_DATE}
                                                            className="form-control form-control-sm" placeholder="Quotation Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="quotation_date">Due Date</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="due_date" id="due_date" defaultValue={quotations.DUE_DATE}
                                                            className="form-control form-control-sm" placeholder="Due Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="quotation_status">Status</label>
                                                    <input type="text" name="quotation_status" id="quotation_status"
                                                        defaultValue={
                                                            quotations.STATUS === 1 ? "IN PROCESS" :
                                                            quotations.STATUS === 2 ? "APPROVED" :
                                                            quotations.STATUS === 3 ? "CANCELED" : ""
                                                        }
                                                        style={{
                                                            textTransform: 'uppercase',
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            backgroundColor:
                                                                quotations.STATUS === 1 ? "#00539B" :
                                                                quotations.STATUS === 2 ? "#198754" :
                                                                quotations.STATUS === 3 ? "#DC3545" : ""
                                                        }}
                                                        className="form-control form-control-sm text-center" placeholder="Status" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="details">Other Comments</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} id="details" name="details" rows='3' defaultValue={quotations.DETAILS}
                                                        className='form-control form-control-sm' onChange={this.changeValue} aria-describedby="helpId"></textarea>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>CUSTOMER INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="customer_id">Customer ID.</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_id" id="customer_id" defaultValue={quotations.ID_CUSTOMER} 
                                                        className="form-control form-control-sm" placeholder="Customer ID." aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="customer_name">Customer Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_name" id="customer_name" defaultValue={quotations.NAME} 
                                                        className="form-control form-control-sm" placeholder="Customer Name" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="customer_address">Customer Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_address" id="customer_address" defaultValue={quotations.ADDRESS} 
                                                        className="form-control form-control-sm" placeholder="Customer Address" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="customer_phone">Customer Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="customer_phone" id="customer_phone" defaultValue={quotations.PHONE} 
                                                            className="form-control form-control-sm" placeholder="Customer Phone" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Customer Phone</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>ITEM INFORMATION</b>
                                            </div>
                                            <form id="form">
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-7">
                                                        <label htmlFor="description">Description</label>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="description" id="description" value={description}
                                                            className={((this.errorVerify("error_description")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Description" aria-describedby="helpId"
                                                            onChange={this.changeValueItem} />
                                                        <small id="helpId" className="invalid-feedback">Please enter Description</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="hud_number">Hud #</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="hud_number" id="hud_number" value={hud_number}
                                                                className="form-control form-control-sm" placeholder="Hud #" aria-describedby="helpId"
                                                                onChange={this.changeValueItem} />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Please enter Hud #</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="amount">Amount</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="amount" id="amount" defaultValue={amount}
                                                                className="form-control form-control-sm" placeholder="Amount" aria-describedby="helpId"
                                                                onChange={this.changeValueItem}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Please enter Amount</small>
                                                    </div>
                                                    <div className="col-md-1 d-flex align-items-end">
                                                        <button type="button" className="btn btn-success btn-sm" onClick={() => this.createItem()}
                                                            disabled={
                                                                quotations.STATUS === 1 ? false :
                                                                quotations.STATUS === 2 ? true :
                                                                quotations.STATUS === 3 ? true : ""
                                                            }
                                                        >
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                            <hr />
                                            {/* <div className='row g-3'>
                                                <div className="col-xl-5">
                                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bitem" name="bitem" placeholder="Search for Item" className="form-control form-control-sm" />
                                                </div>
                                                <div className="col-xl-3">
                                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filter</button>
                                                </div>
                                            </div> */}
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">DESCRIPTION</th>
                                                                <th className="align-middle">HUD #</th>
                                                                <th className="align-middle">AMOUNT</th>
                                                                <th className="align-middle">ACTION</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {load}
                                                            {
                                                                quotationItems.map((itemArrayResult) => (
                                                                    <tr key={itemArrayResult.ID_QUOT_ITEM}>
                                                                        <td>{itemArrayResult.DESCRIPTION}</td>
                                                                        <td>{itemArrayResult.HUD_NUMBER}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemArrayResult.AMOUNT)}</td>
                                                                        <td>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary btn-sm"
                                                                                    data-bs-toggle='modal'
                                                                                    data-bs-target="#PDFItemQuotationModal"
                                                                                    slot='end'
                                                                                    onClick={() => {
                                                                                        this.viewItem(itemArrayResult.ID_QUOT_ITEM)
                                                                                    }}
                                                                                    disabled={
                                                                                        quotations.STATUS === 1 ? false :
                                                                                        quotations.STATUS === 2 ? true :
                                                                                        quotations.STATUS === 3 ? true : ""
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                                </button>&nbsp;&nbsp;
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() =>
                                                                                        this.deleteItem(itemArrayResult.ID_QUOT_ITEM)
                                                                                    }
                                                                                    disabled={
                                                                                        quotations.STATUS === 1 ? false :
                                                                                        quotations.STATUS === 2 ? true :
                                                                                        quotations.STATUS === 3 ? true : ""
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <hr style={{ marginTop: 0 }} />
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="sub_total">Sub Total</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="sub_total" id="sub_total" value={sub_total}
                                                            className="form-control form-control-sm" placeholder="Sub Total" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                            readOnly={
                                                                quotations.STATUS === 1 ? false :
                                                                quotations.STATUS === 2 ? true :
                                                                quotations.STATUS === 3 ? true : ""
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="taxes">Taxes</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="taxes" id="taxes" value={taxes}
                                                            className="form-control form-control-sm" placeholder="Taxes" aria-describedby="helpId"
                                                            onChange={(e) => {
                                                                this.changeValue(e);
                                                                this.calculateTotal(e);
                                                            }}
                                                            readOnly={
                                                                quotations.STATUS === 1 ? false :
                                                                quotations.STATUS === 2 ? true :
                                                                quotations.STATUS === 3 ? true : ""
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="discounts">Discounts</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="discounts" id="discounts" value={discounts}
                                                            className="form-control form-control-sm" placeholder="Discounts" aria-describedby="helpId"
                                                            onChange={(e) => {
                                                                this.changeValue(e);
                                                                this.calculateTotal(e);
                                                            }}
                                                            readOnly={
                                                                quotations.STATUS === 1 ? false :
                                                                quotations.STATUS === 2 ? true :
                                                                quotations.STATUS === 3 ? true : ""
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="total">Total</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="total" id="total" value={total}
                                                            className="form-control form-control-sm" placeholder="Total" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"
                                                    disabled={
                                                        quotations.STATUS === 1 ? false :
                                                        quotations.STATUS === 2 ? true :
                                                        quotations.STATUS === 3 ? true : ""
                                                    }
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Update
                                                </button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterQuotations"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="PDFItemQuotationModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PDFItemQuotationLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="">Quotation Item</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <form id="form_item_quotation">
                                            <div className='row g-3'>
                                                <div className="col-md-7">
                                                    <label htmlFor="edit_description">Description</label>
                                                    <input type="hidden" name="id_quot_item" value={quotationItem.ID_QUOT_ITEM} />
                                                    <input type="hidden" name="user_id" id="user_id" value={window.localStorage.getItem('idusuario')} />
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="edit_description" id="edit_description" defaultValue={quotationItem.DESCRIPTION}
                                                        className={((this.errorVerify("error_edit_description")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Description" aria-describedby="helpId"
                                                        onChange={this.changeValueEditItem} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Description</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="edit_hud_number">Hud #</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="edit_hud_number" id="edit_hud_number" defaultValue={quotationItem.HUD_NUMBER}
                                                            className="form-control form-control-sm" placeholder="Hud #" aria-describedby="helpId"
                                                            onChange={this.changeValueEditItem} />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="edit_amount">Amount</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="edit_amount" id="edit_amount" defaultValue={quotationItem.AMOUNT}
                                                            className="form-control form-control-sm" placeholder="Amount" aria-describedby="helpId"
                                                            onChange={this.changeValueEditItem}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1 d-flex align-items-end">
                                                    <button type="button" className="btn btn-success btn-sm" onClick={() => this.editItem()}>
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PDFQuotationsModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PDFQuotationsModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Quotation</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFQuotations data={quotationData} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Download PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFQuotations data={quotationData} />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;